/**
 * @file 热门应用
 * @author Fanjinliang(fanjinliang@baidu.com)
 */

import React from 'react';
import { HotApp } from '../../types';

interface IProps {
    appList: HotApp;
}

const PaddleNlpHotAppBar: React.FC<IProps> = props => {
    const {
        appList: { list, title }
    } = props;
    return (
        <div className="hot-app-bar-container">
            <div className="hot-app-bar-title">{title}</div>
            <div className="hot-app-bar-list">
                {list.map((item, index) => (
                    <span key={index} onClick={() => window.open(item.desc)}>
                        {item.title}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default PaddleNlpHotAppBar;
